import React from 'react'
import './TweetButton.css'

function TweetButton(props) {
  const tweetUrl = `https://twitter.com/intent/tweet?url=${props.url}&text=${props.text}&hashtags=${props.hashtags}`
  return (
    <a 
      href={tweetUrl}
      className='tweet-button'
      target='_blank'
      rel='noopener noreferrer'
    >
      <button>Tweet your progress</button>
    </a>
  )
}

export default TweetButton
